const state = {
  admin: [],
  adminToken: null,
  adminTokenTime: null,
  sendForm: [],
};

export default state;
